<template>
  <div class="file-item" v-on="listeners">
    <v-btn
      class="file-item__remove"
      color="red"
      @click.stop="$emit('remove')"
      icon
      flat
      small>
      <v-icon>clear</v-icon>
    </v-btn>

    <div class="file-item__icon">
      <img v-if="thumbnailObjUrl" class="file-item__image" :src="thumbnailObjUrl">
      <slot v-else name="icon">
        <v-icon size="7rem">insert_drive_file</v-icon>
      </slot>
    </div>
    <div v-if="showName" class="file-item__name">{{name}}</div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String
    },
    name: {
      type: String
    },
    thumbnailObjUrl: {
      type: String
    },
    autoRevokeObjectUrl: {
      type: Boolean,
      default: false
    },
    showName: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '200px'
    },
    width: {
      type: String,
      default: '200px'
    }
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners
      };
    },

    isImage() {
      let type = this.type || '';
      return type.startsWith('image');
    }
  },

  mounted() {
    this.$el.style.height = this.height;
    this.$el.style.width = this.width;
  },

  beforeDestroy() {
    if (this.thumbnailObjUrl && this.autoRevokeObjectUrl) {
      URL.revokeObjectURL(this.thumbnailObjUrl);
    }
  }
};
</script>

<style lang="stylus" scoped>
.file-item {
  position: relative;
  display: flex;
  flex-direction: column;
  transition: 0.2s;

  &:hover {
    box-shadow: 0 2px 5px -1px rgba(0, 0, 0, 0.3), 0 1px 10px rgba(0, 0, 0, 0.1);
  }

  &:hover .file-item__remove {
    opacity: 1;
  }
}

.file-item__image {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.file-item__remove {
  position: absolute;
  top: -14px;
  right: -14px;
  transform: translate(-50%, 50%);
  transition: 0.2s;
  opacity: 0;
  z-index: 4;
}

.file-item__icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}

.file-item__name {
  flex-grow: 0;
  flex-shrink: 0;
  width: 100%;
  font-size: 1rem;
  padding: 5px;
  text-align: center;
  // make overflow text as '...'
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
